/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Create_Project_References_PartialInputs */



/**
* | output |
* | --- |
* | "The project was created, but these could not be linked: {names}. Add them from the project page." |
*
* @param {Create_Project_References_PartialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_references_partial = /** @type {((inputs: Create_Project_References_PartialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_References_PartialInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Das Projekt wurde erstellt, aber diese konnten nicht verknüpft werden: ${i?.names}. Fügen Sie sie auf der Projektseite hinzu.`)
	return /** @type {LocalizedString} */ (`The project was created, but these could not be linked: ${i?.names}. Add them from the project page.`)
});